import { render, staticRenderFns } from "./1.vue?vue&type=template&id=6afc4135&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
import style0 from "./1.vue?vue&type=style&index=0&id=6afc4135&prod&scoped=true&lang=css"
import style1 from "./1.vue?vue&type=style&index=1&id=6afc4135&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc4135",
  null
  
)

export default component.exports